import TemplateApi from "../api/TemplateApi";
import * as types from "../constants/actionConstants";
import {closeDrawer} from "./drawerActions";
import {setDefaultCategory} from "./questionnaireEditorActions";
import {initGetTemplateList} from "./templateListActions";
import * as TEMPLATE from "../constants/templateConstants";
import * as portalTypes from "../portal/constants/actionConstants";
import {runTrackedTemplateSave} from "./templateSaveActions";
import {
    captureEditorOrigin,
    runIfEditorOwnerActive
} from "../utilities/editorInstanceOwnership";


export function getCategoryTemplate(categoryKey, id) {
    let thunk = (dispatch)=>{

        if (id) {
            TemplateApi.getCategoryById(id).then((categoryTemplate) =>{
                dispatch({type: types.CATEGORY_TEMPLATE_GET_SUCCESS, categoryTemplate});
            });
        }
        else {
            TemplateApi.getCurrentCategory(categoryKey).then((categoryTemplate) =>{
                dispatch({type: types.CATEGORY_TEMPLATE_GET_SUCCESS, categoryTemplate});
            });
        }

        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };

    thunk.meta = {
        debounce: {
            time: 2000,
            key: id || categoryKey,
            leading: true,
            trailing: false
        }
    };

    return thunk;
}

export function saveCategoryTemplate(categoryTemplateObject, persistDrawer = false, setAsDefault = false, parentOrigin = null) {
    const origin = captureEditorOrigin(parentOrigin);
    return (dispatch, getState)=>{
        return runTrackedTemplateSave(dispatch, () =>
            TemplateApi.updateCategoryTemplate(categoryTemplateObject)
            .then((categoryTemplate) =>{
                dispatch({type: types.CATEGORY_TEMPLATE_UPDATE_SUCCESS , categoryTemplate});
                runIfEditorOwnerActive(getState, origin, () => {
                    if (!persistDrawer) {
                        dispatch(closeDrawer());
                    }
                    if (setAsDefault){
                        dispatch(setDefaultCategory(categoryTemplate.templateKey, origin));
                    }
                });
                setTimeout(() => {
                    dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
                }, 500);
                return categoryTemplate;
            })
        );
    };
}

export function saveCategoryTemplateAndCloseDrawer(categoryTemplate, filter, versionsFilter, templateMode, filterState, requestOwner = null) {
    const owner = captureEditorOrigin(requestOwner);
    return (dispatch, getState)=>{
        return runTrackedTemplateSave(dispatch, () =>
            TemplateApi.updateCategoryTemplate(categoryTemplate)
            .then((categoryTemplate) =>{
                dispatch({type: types.CATEGORY_TEMPLATE_UPDATE_SUCCESS , categoryTemplate});
                runIfEditorOwnerActive(getState, owner, () => dispatch(closeDrawer()));
                // Best to load category list page in all cases
                dispatch(initGetTemplateList(filter, TEMPLATE.TYPE.CATEGORY, TEMPLATE.MODE.CURRENT));
                if (templateMode === TEMPLATE.MODE.VERSIONS) {
                    let tempVersionsFilter = {...versionsFilter};
                    tempVersionsFilter.templateName = categoryTemplate.name;
                    tempVersionsFilter.templateKey = categoryTemplate.templateKey;
                    tempVersionsFilter.defaultActions = filterState.defaultActions;
                    dispatch(initGetTemplateList(tempVersionsFilter, TEMPLATE.TYPE.CATEGORY, TEMPLATE.MODE.VERSIONS));
                }
                return categoryTemplate;
            })
        );
    };
}

export function createCategoryTemplate(categoryTemplate, persistDrawer = false, setAsDefault = false, parentOrigin = null) {
    const origin = captureEditorOrigin(parentOrigin);
    return (dispatch, getState) => {
        return runTrackedTemplateSave(dispatch, () =>
            TemplateApi.createCategoryTemplate(categoryTemplate)
            .then((categoryTemplate) => {
                dispatch({type: types.CATEGORY_TEMPLATE_CREATE_SUCCESS, categoryTemplate, origin});
                runIfEditorOwnerActive(getState, origin, () => {
                    if (!persistDrawer) {
                        dispatch(closeDrawer());
                    }
                    if (setAsDefault){
                        dispatch(setDefaultCategory(categoryTemplate.templateKey, origin));
                    }
                });
                setTimeout(() => {
                    dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
                }, 500);
                return categoryTemplate;
            })
        );
    };
}

export function createCategoryTemplateAndCloseDrawer(categoryTemplate, filter, onSuccess = ()=>{}, parentOrigin = null) {
    const origin = captureEditorOrigin(parentOrigin);
    return (dispatch, getState) => {
        return runTrackedTemplateSave(dispatch, () =>
            TemplateApi.createCategoryTemplate(categoryTemplate)
            .then((categoryTemplate) => {
                dispatch({type: types.CATEGORY_TEMPLATE_CREATE_SUCCESS, categoryTemplate, origin});
                runIfEditorOwnerActive(getState, origin, () => {
                    onSuccess();
                    dispatch(closeDrawer());
                });
                dispatch(initGetTemplateList(filter, TEMPLATE.TYPE.CATEGORY, TEMPLATE.MODE.CURRENT));
                return categoryTemplate;
            })
        );
    };
}

// -----------------------------------------------------------------------------------------------------------------
// Category Group Keys
// -----------------------------------------------------------------------------------------------------------------

export function  addCategoryTemplateGroupKey(categoryTemplate, groupKey = []) {
    return (dispatch) => {
        dispatch({type: types.CATEGORY_TEMPLATE_ADD_GROUP_KEY, categoryTemplate: categoryTemplate, groupKey: groupKey});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

// export function  removeCategoryTemplateGroupKey(categoryTemplate, groupKey = []) {
//     return (dispatch) => {
//         dispatch({type: types.CATEGORY_TEMPLATE_REMOVE_GROUP_KEY, categoryTemplate: categoryTemplate, groupKey: groupKey});
//         setTimeout(() => {
//             dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
//         }, 500);
//     };
// }

// ---------------------------------------------------------------------------------------------------------------------
// Category show group keys
// ---------------------------------------------------------------------------------------------------------------------

export function  addCategoryTemplateShowGroupKeys(categoryTemplate, showGroupKeys = []) {
    return (dispatch) => {
        dispatch({type: types.CATEGORY_TEMPLATE_ADD_SHOW_GROUP_KEYS, categoryTemplate: categoryTemplate, showGroupKeys: showGroupKeys});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

// export function  removeCategoryTemplateShowGroupKeys(categoryTemplate, showGroupKeys = []) {
//     return (dispatch) => {
//         dispatch({type: types.CATEGORY_TEMPLATE_REMOVE_SHOW_GROUP_KEYS, categoryTemplate: categoryTemplate, showGroupKeys: showGroupKeys});
//         setTimeout(() => {
//             dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
//         }, 500);
//     };
// }

export function  setCategoryTemplateShowGroupKeys(categoryTemplate, removedGroupKey, showGroupKeys = []) {
    return (dispatch) => {
        dispatch({type: types.CATEGORY_TEMPLATE_SET_SHOW_GROUP_KEYS, removedGroupKey: removedGroupKey, categoryTemplate: categoryTemplate, showGroupKeys: showGroupKeys});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

// -----------------------------------------------------------------------------------------------------------------
// GRAPH !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! <editor-fold>
// -----------------------------------------------------------------------------------------------------------------

export function getCategoryGraph(id) {
    return (dispatch) => {
        TemplateApi.getCategoryGraph(id)
            .then((response) => {
                return dispatch({type: types.GET_CATEGORY_GRAPH_SUCCESS, categoryTemplateGraph: response});
            })
            .catch((error) => {
                dispatch({type: types.GET_CATEGORY_GRAPH_FAILURE});
                console.log(error.message);// eslint-disable-line
            });
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function clearCategoryGraph() {
    return (dispatch) => {
        dispatch({type: types.CLEAR_CATEGORY_GRAPH});
    };
}


// export function getCategoryGraphWithKey(key) {
//     return (dispatch) => {
//         TemplateApi.getCategoryGraphWithKey(key)
//             .then((response) => {
//                 return dispatch({type: types.CATEGORY_GRAPH_GET_SUCCESS, categoryTemplateGraph: response});
//             })
//             .catch((error) => {
//                 dispatch({type: types.CATEGORY_GRAPH_GET_FAILURE});
//                 console.log(error.message);// eslint-disable-line
//             });
//         setTimeout(() => {
//             dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
//         }, 500);
//     };
// }


//</editor-fold>
// -----------------------------------------------------------------------------------------------------------------

